<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header p-2">
            <ul class="nav nav-pills">
              <li class="nav-item"><a class="nav-link active" href="#personalInfo" data-toggle="tab">Personal Info</a></li>
              <li class="nav-item"><a class="nav-link" href="#education" data-toggle="tab">Acdamic Detail</a></li>
            </ul>
          </div><!-- /.card-header -->
          <div class="card-body">
            <div class="tab-content">
              <div class="active tab-pane" id="personalInfo">
                <div class="row">
                  <div class="col-md-12">
                    <table class="table table-borderless table-sm">
                      <tr>
                        <th style="width: 17%">Full Name:</th>
                        <td style="width: 33%">{{lst.Name}}</td>
                        <th style="width: 17%">Father Name:</th>
                        <td style="width: 33%">{{lst.FatherName}}</td>
                      </tr>
                      <tr>
                        <th>CNIC:</th>
                        <td>{{lst.CNIC}}</td>
                        <th>Date Of Birth:</th>
                        <td>{{lst.DateOfBirth}}</td>
                      </tr>
                      <!--<tr>
                          <th>Gender:</th>
                          <td>{{lst.Gender}}</td>

                      </tr>-->
                      <tr>
                        <th>Mobile No:</th>
                        <td>{{lst.MobileNo}}</td>
                        <th>Current Address:</th>
                        <td>{{lst.CurrentAddress}}</td>
                      </tr>
                      <!--<tr>
                          <th>Email:</th>
                          <td>{{lst.Email}}</td>
                          <th>Status:</th>
                          <td>{{lst.Status}}</td>
                      </tr>-->
                      <tr>
                        <th>Admission No:</th>
                        <td>{{lst.AdmissionNo}}</td>
                        <th>Reg No:</th>
                        <td>{{lst.RegistrationNo}}</td>
                      </tr>
                      <tr>
                        <th>Class/Program:</th>
                        <td>{{lst.Class}}</td>
                        <th>Section:</th>
                        <td>{{lst.Section}}</td>
                      </tr>

                    </table>
                  </div>
                </div>
              </div>
              <!-- /.tab-pane -->
              <div class="tab-pane" id="education">
                <div class="row">
                  <div class="col-md-12">
                    <table class="table table-bordered table-sm">
                      <thead class="bg-custom">
                        <tr>
                          <th>Sr. #</th>
                          <th>Institute</th>
                          <th>Branch/City</th>
                          <th>Class</th>
                          <th>Year From</th>
                          <th>Year To</th>
                          <th>Grade</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item,ind) in education">
                          <td>{{ind+1}} </td>
                          <td>{{item.Institute}}</td>
                          <td>{{item.Branch}}</td>
                          <td>{{item.Class}}</td>
                          <td>{{item.YearFrom}}</td>
                          <td>{{item.YearTo}}</td>
                          <td>{{item.Grade}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- /.tab-pane -->
            </div>
            <!-- /.tab-content -->
          </div><!-- /.card-body -->
        </div>
        <!-- /.nav-tabs-custom -->
      </div>
      <!-- /.col -->
    </div>
  </div>
</template>


<script>
  const axios = require('axios').default;

  export default ({

    data() {
      return {
        lst: [],
        education: [],
      }
    },

    created: function () {
      this.pageLoad();
    },

    updated: function () {

    },

    methods: {
      pageLoad() {
        startReq();
        var vm = this;
        axios.post('/api/PortalApi/pageLoadProfile')
          .then(function (res) {
            endReq();
            if (res.data.status) {
              vm.lst = res.data.obj;
              vm.education = res.data.edu;
            }
          })
      },
    },
  });</script>



// WEBPACK FOOTER //
// src/components/profile.vue